import React, { useState, useEffect, useRef } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Typography, Divider, Button, Select, MenuItem, IconButton, Tooltip, Autocomplete, TextField } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import moment from "moment";
import "./TopologyNetworkOrg.css";
import EdgeLinkIcon from "../../asset/image/TopologyLink.svg";
import Inspect_graph from "../../asset/image/Inspect_graph.svg";
import net_diagram_icon from "../../asset/image/net_diagram_icon.svg";
import Vector from "../../asset/image/Vector.svg";
import Inventory_icon from "../../asset/image/Inventory_icon.svg";
import settings_icon from "../../asset/image/settings_icon.svg";
import notification_icon from "../../asset/image/notification_icon.svg";
import TopologyIc from "../../asset/image/TopologyIc.svg"
import AnalyticsIC from "../../asset/image/analytics.svg"
import EdgeLinkIconDisabled from "../../asset/image/linkDisabled.svg"
import { convertDateTimeIntoTimezone, getDataFromLocalStorageParsed, getDecodeURI, getEncodedURI, readableBytesAsGB, redirectToTopolgyTabs } from "../../utils/util";
import ImageWithFallback from "../../components/ImageWithFallback";
import { getTopologyDeviceInfo, resetTopologyDeviceInfo } from "../../actions/Users/authenticateService";
import { MMDDYYYYHMMSS_DATE_FORMAT_24_HRS } from "../../utils/constants";
import { clearData, getGeneratedLinks } from "../../components/RemoteConnections/remoteConnectionSlice";
import _ from "lodash";
import { displayToastError } from "../../server/request";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Badge from '@mui/material/Badge';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { T103_TIER } from "../../components/InventoryDeployedTable";

const UsageScroller = ({ wanUsageSplit}) => {
    const usageItems = wanUsageSplit?.split("|") || [];
    const [startIndex, setStartIndex] = useState(0);
  
    const visibleItems = usageItems.slice(startIndex, startIndex + 3);
  
    const handleNext = () => {
      if (startIndex + 1 < usageItems.length) {
        setStartIndex(startIndex + 1);
      }
    };
  
    const handlePrev = () => {
      if (startIndex > 0) {
        setStartIndex(startIndex - 1);
      }
    };
  
    return (
      <div className="scroller-wrapper">
        <button onClick={handlePrev} className="nav-button" disabled={startIndex === 0}>
          <span className="arrow-icon">{<ChevronLeftIcon/>}</span>
        </button>
  
        <div className="scroller-container">
          {visibleItems.map((item, index) => {
            const [key, value] = item.split("=");
            return (
              <div key={index} className="usage-item">
                <div className="displayFlex height12">
                    <div className={`usage-label-name topoElipse`}>
                        {`${key.charAt(0).toUpperCase() + key.slice(1)} `}
                    </div>
                </div>
                <div className="displayFlex height15">
                    <div className="usage-amount-value">{readableBytesAsGB(value).replace(" GB", "")}</div>
                    <div className="usage-gb">{" (GB)"}</div>
                </div>
              </div>
            );
          })}
        </div>
  
        <button
          onClick={handleNext}
          className="nav-button"
          disabled={startIndex + 2 >= usageItems.length}
        >
          <span className="arrow-icon">{<ChevronRightIcon/>}</span>
        </button>
      </div>
    );
  };

const HardcodedOverlay = (props: any) => {
    const { location, selectedTopoDetails, selectedNameList, open, setOpen, getTopologyDeviceInfo, selectedSiteId, setSelectedSiteId, networkTopologyDeviceInfo, authReducer, resetTopologyDeviceInfo, getGeneratedLinks, isSite, networkTopologySiteSetailsLoading, networkTopologyDeviceInfoLoading, openTopologyCards } = props;
    const dispatch = useDispatch();
    console.log("networkTopologyDeviceInfohere", selectedTopoDetails)
    const [selectedIdDetails, setSelectedIDDetails] = useState<any>({})
    const [selectedTerminalOrDev, setSelectedTerminalOrDev] = useState("");
    const [devicesOrterminals, setDevicesOrTerminals] = useState<any[]>([])
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        console.log("networkTopologyDeviceInfo", networkTopologyDeviceInfo)
        if (!networkTopologyDeviceInfo?.data) {
            console.log("setting Empty")
            setSelectedTerminalOrDev(""); // Reset dropdown selection
        }
    }, [networkTopologyDeviceInfo]);

    useEffect(() => {
        console.log("networkTopologySiteSetails", networkTopologyDeviceInfo)
        let tableData = networkTopologyDeviceInfo?.data?.rows.map((item) => {
            return networkTopologyDeviceInfo?.data?.columns.reduce((vsd, columnitem, i) => {
                vsd[columnitem] = item[i]
                return vsd;
            }, {})
        })
        if (tableData && tableData.length > 0) {
            setSelectedIDDetails(tableData[0])
        } else {
            setSelectedIDDetails({})
        }
    }, [networkTopologyDeviceInfo])


    // let devices: any = []
    // if (selectedTopoDetails && selectedTopoDetails?.device_list) {
    //     devices = selectedTopoDetails?.device_list && selectedTopoDetails?.device_list?.split(",").map((item) => {
    //         const [key, value] = item?.split("=");
    //         return { key, value };
    //     });
    // }

    useEffect(() => {
        let devices: any = [];
        if (selectedTopoDetails?.device_list) {
            devices = selectedTopoDetails.device_list.split(",").map((item) => {
                const [key, value] = item.split("=");
                return { key, value };
            });
        } else if (selectedTopoDetails?.userTerminalDetails) {
            devices = selectedTopoDetails.userTerminalDetails.split(",").map((item) => {
                const [key, value] = item.split("=");
                return { key, value };
            });
        }
        setDevicesOrTerminals(devices)
        // Auto-select the only device if there's exactly one
        if (devices.length === 1) {
            console.log("devices[0].key", devices[0].key)
            setSelectedTerminalOrDev(devices[0].key);
        }
    }, [selectedTopoDetails]);


    const handleDeviceChange = (e) => {
        console.log("value", e?.target?.value)
        if (e?.target?.value) {
            // resetTopologyDeviceInfo()
            setSelectedTerminalOrDev(e?.target?.value)
        }
    }

    // const hasSetInitialDevice = useRef(false);

    // useEffect(() => {
    //     if (open && devices.length > 0 && !hasSetInitialDevice.current) {
    //         const firstDeviceKey = devices[0].key;
    //         setSelectedTerminalOrDev(firstDeviceKey);
    //         hasSetInitialDevice.current = true; // Ensures this runs only once
    //     }
    // }, [open, devices]);

    // useEffect(() => {
    //     if (selectedTerminalOrDev && selectedSiteId) {
    //         getTopologyDeviceInfo(selectedSiteId, selectedTerminalOrDev, isSite);
    //     }
    // }, [selectedTerminalOrDev, selectedSiteId]);

    useEffect(() => {
        if (selectedTerminalOrDev && selectedSiteId && isSite) {
            getTopologyDeviceInfo(selectedSiteId, selectedTerminalOrDev, isSite)
        }
    }, [selectedTerminalOrDev, selectedSiteId, isSite])

    function GetTopAppsImage(props) {
        console.log("each props", props)
        const { app } = props;
        if (app) {
            console.log("GETTING INSIDE")
            let appName = app.includes(' ') ? app.split(' ')[0] : app.includes('-') ? app.split('-')[0] : "";
            return <ImageWithFallback src={`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${app.trim()}`} fallbackSrcs={[`https://cdn.k4mobility.com/cdn/sportAssets/app_icons/${appName.trim()}`, "https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png"]} app={app} />
        } else {

            return <img className="logo-activity paddingLogo" src={`https://cdn.k4mobility.com/cdn/sportAssets/fallbackImg.png`} />
        }

    }

    console.log("selectedTerminalOrDev out", selectedTerminalOrDev)
    const handlePopupClose = () => {
        setOpen(false)
        resetTopologyDeviceInfo()
        setSelectedSiteId(); 
    }

    const EDGE_PORTAL_ADDRESS = "127.0.0.1"
    const EDGE_PORTAL_PORT = 80
    const MAX_WAIT_TIME = 20

    const onConnectToEdge = async (e, deviceId: any) => {
        e.preventDefault()
        let resp: any = await getGeneratedLinks(selectedSiteId, deviceId, { address: [EDGE_PORTAL_ADDRESS] })
        if (!_.isEmpty(resp?.result)) {
            let [edgeLink] = resp.result?.filter(rc => {
                return rc?.address === EDGE_PORTAL_ADDRESS && rc.port === EDGE_PORTAL_PORT && rc.alias.includes("Portal")
            });
            if (edgeLink && edgeLink.url) {
                let url = edgeLink.url;
                const loggedInUser = getDataFromLocalStorageParsed("loggedInUser");
                let edgeToken = loggedInUser?.data?.edge_token;
                if (!_.isEmpty(edgeToken)) {
                    let objUrl = new URL(`/login?token=${edgeToken}`, `${url}`)
                    url = objUrl?.href
                }
                window.open(url)
                clearData()
            }
        } else {
            displayToastError('No remote connection link found')
        }
    }

    const handleInsightsClick = (k4id, siteName) => {
        console.log("insight click ", k4id, siteName)
        // const newTabURL = `/fleet-dashboard/sites/SDWAN?k4Ids=?k4Ids=${encodeURIComponent(k4id+":"+siteName)}`;
        // console.log("newTabURL",newTabURL)
        // window.open(newTabURL, "_blank");


    };

    const textRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        const checkOverflow = () => {
            if (textRef.current) {
                setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
            }
        };

        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, [selectedNameList]);
    return open ? (

        <div className={`overlay-container overlay-topology topologyPopupPosition ${openTopologyCards ? "topo-popup-top" : "topo-popup-top1"}`}>
            

            {isSite == "SITE" ? <>
                <div>
                    <div className="internetStatusdiv">
                        <div ref={textRef}  className={`titleTypo colorblackOverride topologuPopupHeader topologyElipse topoSiteHeadingWidth ${isOverflowing ? "overflowing" : ""}`}>
                            {selectedNameList ? selectedNameList.split(", ")[0] : "Hirarchy"}
                        </div>
                        <div id={selectedTopoDetails?.Internet_status==="Online" ? "smallGreenDot" : "smallRedDot"}></div>
                        <div className="internetStatusFont">{selectedTopoDetails?.Internet_status}</div>
                        <Badge badgeContent={selectedTopoDetails?.total_alerts} 
                            className="custom-badge">
                                <img src={notification_icon} className="alertsIcon"/>
                            {/* <NotificationsNoneIcon className="alertsIcon"/> */}
                        </Badge>
                        { (networkTopologySiteSetailsLoading || networkTopologyDeviceInfoLoading) ? <div className="cancel-button colorblackOverride"> <CircularProgress size={12}/> </div> :
                        <button
                            className="closeTopologyPopup"
                            onClick={() => handlePopupClose()}
                        >
                            ✕
                        </button>}
                    </div>
                </div>
                <div className={`titleTypo colorblackOverride topologuPopupSecondHeader topologyElipse ${isOverflowing ? "overflowing" : ""}`}>{selectedNameList ? selectedNameList.split(", ")[1] : "Hirarchy"}</div>
                <Divider className="topologyDivider marginTop" />
                <div className="titleTypo colorblackOverride">
                    <div className="topologyTopApps">
                        {selectedTopoDetails?.apps?.split(',').map((app, index) => (
                            <GetTopAppsImage key={index} app={app} />
                        ))}
                    </div>
                </div>
                <div className="usage-container colorblackOverride">
                    <div className="topo-header-row padding8">
                        <div className="topo-header-box">
                            <div className="topo-header-title">Usage (GB)</div>
                            <div className="topo-header-value">{readableBytesAsGB(selectedTopoDetails?.total_usage).replace(" GB", "")}</div>
                        </div>
                        <div className="topo-header-box">
                            <div className="topo-header-title">Availability (%)</div>
                            <div className="topo-header-value">{selectedTopoDetails?.availibility}</div>
                        </div>
                    </div>
                    <UsageScroller wanUsageSplit={selectedTopoDetails?.wan_usage}/>
                    <div className="topo-header-row padding8 paddingTop8">
                        <div className="topo-header-box">
                            <div className="topo-header-title">Quota</div>
                            <div className="topo-header-value color5f5fff">{selectedTopoDetails?.current_quota?.split(",").map(value => parseFloat(value).toFixed(2)).join(",")}</div>
                        </div>
                    </div>
                    
                </div>
            </> :
                isSite == "STARLINK" ? <>
                    <div className="displayFlex">
                        <div ref={textRef} className={`titleTypo colorblackOverride topologuPopupHeader topologyElipse ${isOverflowing ? "overflowing" : ""}`}>
                            {selectedNameList ? selectedNameList.split(", ")[0] : "Hirarchy"}
                        </div>

                        { (networkTopologySiteSetailsLoading || networkTopologyDeviceInfoLoading) ? <div className="cancel-button colorblackOverride"> <CircularProgress size={12}/> </div> :
                            <button
                                className="closeTopologyPopup marginLeftAuto"
                                onClick={() => handlePopupClose()}
                            >
                                ✕
                            </button>}
                    </div>
                    <Typography className={`titleTypo colorblackOverride topologuPopupSecondHeader topologyElipse ${isOverflowing ? "overflowing" : ""}`}>{selectedNameList ? selectedNameList.split(", ")[1] : "Hirarchy"}</Typography>
                    <Divider className="topologyDivider marginTop" />
                    <div className="topology-popup-container">
                        <div className="topologyStarlinkHeader1">
                            {`SL Number`}
                        </div>
                        <div className="topologyStarlinkHeader2">
                            {selectedTopoDetails?.serviceLineNumber}
                        </div>
                        <div className={`topologyStarlinkHeader1 padding6`}>
                            {`Plan - ${selectedTopoDetails?.servicePlan}`}
                        </div>
                        <div className="topo-header-row padding6">
                            <div className="topo-header-box">
                                <div className="topo-header-title">Usage (GB)</div>
                                <div className="topo-header-value">{readableBytesAsGB(selectedTopoDetails?.allTypeUsageGB).replace(" GB", "")}</div>
                            </div>
                        </div>
                        <UsageScroller wanUsageSplit={selectedTopoDetails?.usageSplit} />
                    </div>
                </> :
                    <>
                        {/* <Tooltip title={<span>{selectedNameList ? selectedNameList.split(", ").reverse().join(" / ") : "Hirarchy"}</span>}> */}
                        <div className="displayFlex topo-headerHeight">
                            <div ref={textRef} className={`titleTypo colorblackOverride topologuPopupHeader topologyElipse ${isOverflowing ? "overflowing" : ""}`}>
                                {selectedNameList ? selectedNameList.split(", ")[0] : "Hirarchy"}
                            </div>
                            <Badge badgeContent={selectedTopoDetails?.total_alerting} 
                                className="custom-badge">
                                    <img src={notification_icon} className="alertsIcon"/>
                                {/* <NotificationsNoneIcon className="alertsIcon"/> */}
                            </Badge>
                            { (networkTopologySiteSetailsLoading || networkTopologyDeviceInfoLoading) ? <div className="cancel-button colorblackOverride"> <CircularProgress size={12}/> </div> :
                            <button
                                className="closeTopologyPopup"
                                onClick={() => handlePopupClose()}
                            >
                                ✕
                            </button>}
                        </div>
                        {/* </Tooltip> */}
                        <Typography className={`titleTypo colorblackOverride topologuPopupSecondHeader topologyElipse ${isOverflowing ? "overflowing" : ""}`}>{selectedNameList ? selectedNameList.split(", ")[1] : "Hirarchy"}</Typography>
                        <Divider className="topologyDivider marginTop" />
                        <div className="topology-popup-container">
                            <div className="topo-header-row">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Usage (GB)</div>
                                    <div className="topo-header-value">{readableBytesAsGB(selectedTopoDetails?.total_usage).replace(" GB", "")}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Availability (%)</div>
                                    <div className="topo-header-value">{selectedTopoDetails?.total_availibility}</div>
                                </div>
                            </div>
                            <UsageScroller wanUsageSplit={selectedTopoDetails?.wan_usage_split}/>
                        </div>
                        <Divider className="topologyDivider" />
                        <div className="topology-popup-container">
                            <Typography className="topology-second-header">
                                Organization Summary
                            </Typography>
                            <div className="topo-header-row">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Devices</div>
                                    <div className="topo-header1-value">{selectedTopoDetails?.online_devices} / {selectedTopoDetails?.total_devices}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Active Licences</div>
                                    <div className="topo-header1-value">{selectedTopoDetails?.active_license}</div>
                                </div>
                            </div>
                            {selectedTopoDetails?.licese_distribution?.split("|").reduce((rows, item, index, array) => {
                                if (index % 2 === 0) {
                                    const pair = array.slice(index, index + 2);
                                    rows.push(pair);
                                }
                                return rows;
                            }, []).map((pair, rowIndex) => (
                                <div key={rowIndex} className="topo-header-row">
                                    {pair.map((item, index) => {
                                        const [key, value] = item.split("=");
                                        return (
                                            <div key={index} className="topo-header-box">
                                                <div className="topo-header-title">
                                                    {key.charAt(0).toUpperCase() + key.slice(1)}
                                                </div>
                                                <div className="topo-header1-value">{value}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </>

            }
            {(isSite == "SITE" || isSite == "STARLINK") && 
              <div className="colorblackOverride">
                <div>
                    <div className="terminal-item colorblackOverride padding10">
                        <Select
                            fullWidth
                            size="small"
                            value={selectedTerminalOrDev}
                            className="strMaps-custom-select strMap-sl-dropdown topologyPopUpSelect"
                            onChange={handleDeviceChange}
                            displayEmpty
                            disableUnderline // Removes underline
                            IconComponent={(props) => (
                                <ExpandMoreIcon {...props} sx={{ color: "#8B8D97", width: "5.48px", height: "2.74px" }} />
                            )}
                        >
                            <MenuItem value="" disabled>Select a Device</MenuItem>
                            {devicesOrterminals.map(({ key, value }) => (
                                <MenuItem key={key} value={key}>{value}</MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div>
                        <Divider className="topologyDivider" />
                    </div>
                </div>
                {isSite == "SITE" ? <div className="topo-site-div-padding">
                    <Typography className="topology-second-header">
                             Access Network Details
                    </Typography>
                    <div className="topo-header-row">
                        <div className="topo-header-box">
                            <div className="topo-header-title">DID</div>
                            <div className="topo-header1-value">{selectedIdDetails?.deviceId ? selectedIdDetails?.deviceId : ""}</div>
                        </div>
                    </div>
                    <div className="topo-header-row">
                        <div className="topo-header-box">
                            <div className="topo-header-title">Software Version</div>
                            <div className="topo-header1-value">{selectedIdDetails?.software_version ? selectedIdDetails?.software_version.split("~")[0] : ""}</div>
                        </div>
                        <div className="topo-header-box">
                            <div className="topo-header-title">Licence Type</div>
                            <div className="topo-header1-value">{selectedIdDetails?.licence_type ? selectedIdDetails?.licence_type : ""}</div>
                        </div>
                    </div>
                    <div className="topo-header-row">
                        <div className="topo-header-box">
                            <div className="topo-header-title">Coordinates</div>
                            <div className="topo-header1-value color5f5fff">{selectedTopoDetails?.cordinates?.split(",")
                            .map(num => Number(parseFloat(num).toFixed(2)))
                            .join(", ")}</div>
                        </div>
                    </div>
                    <div className="topo-header-row height43">
                        <div className="topo-header-box">
                            <div className="topo-header-title">Last Online</div>
                            <div className="topo-header1-value height30">{selectedIdDetails?.last_online ? convertDateTimeIntoTimezone(selectedIdDetails?.last_online, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : ""}</div>
                        </div>
                    </div>
                </div> :
                    isSite == "STARLINK" ?
                        <div className="topology-popup-container">
                            <div className="topo-header-row padding8">
                                <div className="topo-header-box width100">
                                    <div className="topo-header-title">Terminal ID</div>
                                    <div className="topo-header-value">{selectedTerminalOrDev ? selectedTerminalOrDev : ""}</div>
                                </div>
                            </div>
                            <div className="topo-header-row padding8">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Obstruction</div>
                                    <div className="topo-header-value">{selectedIdDetails?.obstruction_percent_time ? `${selectedIdDetails?.obstruction_percent_time.toFixed(2)} %` : ""}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Signal Quality</div>
                                    <div className="topo-header-value">{selectedIdDetails?.signal_quality ? `${selectedIdDetails?.signal_quality.toFixed(2)} %` : ""}</div>
                                </div>
                            </div>
                            <div className="topo-header-row padding8">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Downlink</div>
                                    <div className="topo-header-value">{selectedIdDetails?.downlink_throughput ? `${selectedIdDetails?.downlink_throughput.toFixed(2)} Mbps` : ""}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">UpLink</div>
                                    <div className="topo-header-value">{selectedIdDetails?.uplink_throughput ? `${selectedIdDetails?.uplink_throughput.toFixed(2)} Mbps` : ""}</div>
                                </div>
                            </div>
                            <div className="topo-header-row padding8">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Ping Drop Rate</div>
                                    <div className="topo-header-value">{selectedIdDetails?.ping_drop_rate_avg ? `${selectedIdDetails?.ping_drop_rate_avg.toFixed(2)} %` : ""}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Latency</div>
                                    <div className="topo-header-value">{selectedIdDetails?.ping_latency_ms_avg ? `${selectedIdDetails?.ping_latency_ms_avg.toFixed(2)} ms` : ""}</div>
                                </div>
                            </div>
                            <div className="topo-header-row padding8">
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Last Online</div>
                                    <div className="topo-header-value">{selectedIdDetails?.last_online ? convertDateTimeIntoTimezone(selectedIdDetails?.last_online, authReducer.userTimezone, MMDDYYYYHMMSS_DATE_FORMAT_24_HRS) : ""}</div>
                                </div>
                                <div className="topo-header-box">
                                    <div className="topo-header-title">Uptime</div>
                                    <div className="topo-header-value">{selectedIdDetails?.uptime ? selectedIdDetails?.uptime.toFixed(2) : ""}</div>
                                </div>
                            </div>
                        </div>
                        :
                        <>
                        </>
                }                

              </div>}
            <div className="marginBottom8">
                <Divider className="topologyDivider" />
            </div>
            <div className="d-flex str-justify-between str-mt-0 topologyIconMarginAuto">

                <Link className="topo-bottom-buttons" title="Inventory">
                    <Button size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension'>
                        <IconButton className="strMap-SettingsIcon" size='small'>
                            <img src={Inventory_icon} className="iconDimesion"/>
                        </IconButton>
                    </Button>
                </Link>

                {selectedIdDetails.konnect_status === "STATUS_CONNECTED" && selectedIdDetails?.licenseTier !== T103_TIER  && isSite !== "ORG "?
                  <Link className="topo-bottom-buttons" title="remote connection">
                    <Button size="small" variant="contained" onClick={(e) => onConnectToEdge(e, selectedIdDetails.deviceId)} className='starlink--button_contained--primary topoButtonDimension'>
                        <IconButton className="strMap-SettingsIcon" size='small'>
                            <img src={Vector} className="iconDimesion"/>
                        </IconButton>
                    </Button>
                  </Link>
                    : selectedIdDetails.konnect_status === "STATUS_NOT_FOUND" ?
                      <Link className="topo-bottom-buttons" title="portal">
                        <Button size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension'>
                            <IconButton className="strMap-SettingsIcon" size='small'>
                                <img src={Vector} className="iconDimesion"/>
                            </IconButton>
                        </Button>
                      </Link>
                        : selectedIdDetails?.konnect_status ? "-" :
                      <Link className="topo-bottom-buttons" title="portal">
                            <Button size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension'>
                                <IconButton className="strMap-SettingsIcon" size='small'>
                                    <img src={EdgeLinkIconDisabled} className="iconDimesion"/>
                                </IconButton>
                            </Button>
                      </Link>
                }

                <Link to={redirectToTopolgyTabs(location, "/fleet-dashboard/sites/topology", selectedSiteId, selectedTopoDetails?.sitename, {}, true, false, null)} className="topo-bottom-buttons" title="topology">
                    <Button size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension'>
                        <IconButton className="strMap-SettingsIcon" size='small'>
                            <img src={net_diagram_icon} className="iconDimesion"/>
                        </IconButton>
                    </Button>
                </Link>



                {/* <Button size="small" variant="contained" className='starlink--button_contained--primary'>Site</Button> */}

                <Link to={redirectToTopolgyTabs(location, "/fleet-dashboard/sites/SDWAN", selectedSiteId, selectedTopoDetails?.sitename, {}, true, false)} className="topo-bottom-buttons" title="sdwan">
                    <Button onClick={() => handleInsightsClick(selectedSiteId, selectedTopoDetails?.sitename)} size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension topoButton'>
                        <IconButton className="strMap-SettingsIcon analyticsIc" size='small'>
                            <img src={Inspect_graph} className="iconDimesion"/>
                        </IconButton>
                    </Button>
                </Link>

                <Link to={redirectToTopolgyTabs(location, "", selectedSiteId, selectedTopoDetails?.sitename, {}, true, false, null)} className="topo-bottom-buttons" title="Settings">
                    <Button size="small" variant="contained" className='starlink--button_contained--primary topoButtonDimension'>
                        <IconButton className="strMap-SettingsIcon" size='small'>
                            <img src={settings_icon} className="iconDimesion"/>
                        </IconButton>
                    </Button>
                </Link>
                {/* <Button size="small" variant="contained" className='starlink--button_contained--primary'>
                    <IconButton className="strMap-SettingsIcon" size='small'>
                        <SettingsIcon />
                    </IconButton>
                </Button> */}
            </div>
        </div>

    ) : null
};

const mapStateToProps = (state) => ({
    authReducer: state?.authReducer,
    selectedOu: state.authReducer?.selectedOu,
    networkTopologyDeviceInfo: state?.authReducer?.networkTopologyDeviceInfo,
    networkTopologySiteSetailsLoading: state?.authReducer?.networkTopologySiteSetailsLoading,
    networkTopologyDeviceInfoLoading: state?.authReducer?.networkTopologyDeviceInfoLoading
});

export default withRouter(
    connect(mapStateToProps, { getTopologyDeviceInfo, resetTopologyDeviceInfo, getGeneratedLinks })(HardcodedOverlay)
);